export var componentsLocales = {
  notFound: 'Не найдено',
  errorNetworkButton: 'Обновить',
  errorNetworkMessage: 'Что-то пошло не так. Проверьте соединение с интернетом и попробуйте еще раз'
};